import React, { useState, useEffect } from 'react';
import { Col, Row } from 'antd';

const Quantity = ({
  text,
  max,
  min = 1,
  disabled,
  change,
  onRemove,
}) => {
  const [textValue, setTextValue] = useState('');

  useEffect(() => {
    if (
      textValue !== '' &&
      textValue !== null &&
      textValue !== undefined &&
      Number(textValue) !== Number(text)
    ) {
      change(textValue);
    }
  }, [textValue, text]);

  useEffect(() => {
    setTextValue(text);
  }, [text]);

  const parseValue = (value) => {
    if (value === '' || value === null || value === undefined) return null;
    const parsed = Number(value);
    if (!Number.isInteger(parsed)) return null;
    return parsed;
  };

  const handleDecrement = () => {
    if (disabled) return;
    const current = parseValue(textValue);
    if (current === null) return;

    if (current <= min) {
      if (onRemove) onRemove();
      return;
    }

    setTextValue(current - 1);
  };

  const handleIncrement = () => {
    if (disabled) return;
    const current = parseValue(textValue);
    if (current === null) return;

    if (max !== undefined && current >= max) return;
    setTextValue(current + 1);
  };

  const handleChange = (rawValue) => {
    if (rawValue === '') {
      setTextValue('');
      return;
    }

    const parsed = parseValue(rawValue);
    if (parsed === null) return;

    // Reject negatives; treat 0 as remove when supported.
    if (parsed < 0) return;

    if (parsed === 0) {
      if (onRemove) onRemove();
      return;
    }

    if (parsed < min) return;

    if (max !== undefined && parsed > max) {
      setTextValue(max);
      return;
    }

    setTextValue(parsed);
  };

  return (
    <Row>
      <Col span={16} offset={4}>
        <Row style={{ textAlign: 'center' }}>
          <Col
            span={6}
            className={!disabled && 'clickable'}
            onClick={handleDecrement}
          >
            {'<'}
          </Col>
          <Col span={12} className="quantity">
            <input
              type="number"
              disabled={disabled}
              min={min}
              max={max}
              value={String(textValue).replace(/^0+(?!$)/g, '')}
              onChange={(e) => handleChange(e.target.value)}
              onWheel={(e) => e.target.blur()}
            />
          </Col>
          <Col
            span={6}
            className={!disabled && 'clickable'}
            onClick={handleIncrement}
          >
            {'>'}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Quantity;
